import { TeamChatUserStatusV1 } from '@frontend/api-team-chat-user-status';

/**
 * Hook to fetch prerequisite data about user message details before initializing Stream client
 * This is used to determine whether to initialize the Stream client based on user having unread messages
 */
export const useUserMessageDetails = (orgId: string, userId: string) => {
  const { data, isLoading, error } = TeamChatUserStatusV1.Queries.useGetUserMessageDetailsQuery({
    request: { orgId, userId },
  });

  return {
    hasUnreadMessages: data?.hasReceivedMessage || false,
    isLoading,
    error,
  };
};
